import { BehaviorSubject, Observable } from 'rxjs';
import { AbstractCmsList } from '../../abstract-cms-list';
import { FieldSetting } from '../../../../share/entity/FieldSetting';
import { CmsNormal } from './cms-normal';
import { Page } from '../../entity/page';
import { OnInit } from '@angular/core';

export abstract class AbstractCmsNormal extends AbstractCmsList<Page<CmsNormal>> implements OnInit {
  limit$ = new BehaviorSubject<number>(10);
  offset$ = new BehaviorSubject<number>(10);

  moduleKey = 'NORMAL';
  menuSetting: { [p: string]: FieldSetting } = {
    search: { title: 'search', isDefault: true, openStatus: true },
    //category: { title: 'category', isDefault: true, searchStatus: true },
    // keywords: { title: 'keywords', isDefault: true, searchStatus: true },
  };
  data = {
    menuSetting: this.menuSetting
  };

  i18nLanguageWords: any = {};

  /** 分類 option */
  categoryOption = [];

  ngOnInit() {
    super.ngOnInit();
    this.translate.get('filterBy', { filter: '' }).subscribe(t => {
      this.i18nLanguageWords.filterBy = t;
    });
    this.translate.get('all').subscribe(t => {
      this.i18nLanguageWords.all = t;
    });

    this.getCategory().subscribe(data => {
      this.categoryOption = data.map(item => {
        return  {label: item, value: item};
      })
    });
  }

  querySearch(term: any, key?: string) {
    if (term && 'category' in term) {
      term['menuCategory'] = term['category'];
    } else if (key) {
      term = { [key]: term };
    }
    super.search(term);
  }

  fetchDataObs(params: any): Observable<any> {
    return this.http.get<Page<CmsNormal>>(`${this.generatorEnv.apiHost}/api/${this.translate.currentLang}/cm/normal/${params.cmsType}`, { params: params.params });
  }

  getCategory(): Observable<any> {
    return this.http.get<any>(`${this.generatorEnv.apiHost}/api/${this.translate.currentLang}/cm/normal/${this.path}/category`);
  }
}
